<template>
  <div class="manualBinding">
    <div class="barcodeBox">
      <div class="key">试管条码号</div>
      <div class="value">
        <input
          type="tel"
          placeholder="请输入试管条码号"
          v-model="code"
        >
      </div>
    </div>
    <div
      class="nextBtn"
      v-show="btnFlag"
      @click="goBindingUserInfo"
    >下一步</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      btnFlag:true
    };
  },
  created() {
    if (!localStorage.getItem("systemUserInfo")) {
      localStorage.setItem("redirect", location.hash.slice(1));
      this.$router.replace({
        name: "nurseLogin"
      });
    }
  },
  methods: {
    goBindingUserInfo() {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        if (!this.code) {
          this.$toots("请输入试管条码号");
          return;
        }
        this.$nurseBindBox(this.code);
      }
    }
  },
  mounted() {
    let winh = document.body.clientHeight; // 取窗口可视范围的高度
    window.addEventListener("resize", () => {
      if (document.body.clientHeight < winh) {
        this.btnFlag = false; //隐藏按钮
      } else {
        this.btnFlag = true; //显示按钮
      }
    });
  }
};
</script>

<style lang='less' scoped>
.manualBinding {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 110px 40px 90px 40px;
  background-color: #fff;
  height: 100%;
  .barcodeBox {
    .key {
      font-size: 36px;
      line-height: 54px;
      font-weight: 700;
    }
    .value {
      border-bottom: 1PX solid #eee;
      height: 100px;
      input {
        font-size: 30px;
        margin-top: 40px;
        width: 100%;
      }
      input::placeholder {
        font-size: 30px;
        color: #cccccc;
      }
    }
  }
  .nextBtn {
    width: 100%;
    height: 88px;
    background: #1968a8;
    color: #fff;
    text-align: center;
    line-height: 88px;
    border-radius: 88px;
    font-size: 30px;
  }
}
</style>
